import React from 'react';
import svgLogo from './svgviewer-output(5).svg';

const styles = {
  position: 'fixed',
  left: 0,
  right: 0,
  top: 'calc(50% - 20px)',
  margin: 'auto',
  height: '100px',
  width: '100px',
  zIndex: 324324324
};

const Loading = () => {
  return (
    <div style={styles}>
      {/* <div className="spinner spinner-bubble spinner-bubble-primary"></div> */}
      <img src={svgLogo} style={{ height: '100%', width: '100%' }} alt="Loading" />
    </div>
  );
};

export default Loading;
